<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router'
import { Button } from '@/components/ui/button'
import { Users, Building2, FolderOpen, FolderTree, Home, NotepadTextDashed, CreditCard, Globe, Mail, Sparkles, ScrollText, Bot } from 'lucide-vue-next'
import { DialogCreateProject } from '@/components/dialogs'

const router = useRouter()
const route = useRoute()

const isActive = (path: string) => {
  return route.path === path || route.path.startsWith(path + '/')
}

const isExactMatch = (path: string) => {
  return route.path === path || route.path === path + '/'
}
</script>

<template>
  <div class="bg-muted/50 border-b px-6 py-3">
    <div class="flex flex-wrap gap-2">
      <Button
        :variant="isExactMatch('/admin') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin')"
      >
        <Home class="mr-2 h-4 w-4" />
        Dashboard
      </Button>
      <Button
        :variant="isActive('/admin/users') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin/users')"
      >
        <Users class="mr-2 h-4 w-4" />
        Members
      </Button>
      <Button
        :variant="isActive('/admin/organizations') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin/organizations')"
      >
        <Building2 class="mr-2 h-4 w-4" />
        Organizations
      </Button>
      <Button
        :variant="isActive('/admin/templates') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin/templates')"
      >
        <NotepadTextDashed class="mr-2 h-4 w-4" />
        Templates
      </Button>
      <Button
        :variant="isActive('/admin/workflows') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin/workflows')"
      >
        <FolderTree class="mr-2 h-4 w-4" />
        Workflows
      </Button>
      <Button
        :variant="isActive('/admin/skills') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin/skills')"
      >
        <Sparkles class="mr-2 h-4 w-4" />
        Skills
      </Button>
      <Button
        :variant="isActive('/admin/agents') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin/agents')"
      >
        <Bot class="mr-2 h-4 w-4" />
        Agents
      </Button>
      <Button
        :variant="isActive('/admin/payments') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin/payments')"
      >
        <CreditCard class="mr-2 h-4 w-4" />
        Payments
      </Button>
      <Button
        :variant="isActive('/admin/planet') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin/planet')"
      >
        <Globe class="mr-2 h-4 w-4" />
        Planet
      </Button>
      <Button
        :variant="isActive('/admin/emails') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin/emails')"
      >
        <Mail class="mr-2 h-4 w-4" />
        Emails
      </Button>
      <Button
        :variant="isActive('/admin/prompts') ? 'default' : 'outline'"
        size="sm"
        @click="router.push('/admin/prompts')"
      >
        <ScrollText class="mr-2 h-4 w-4" />
        Prompts
      </Button>
      <DialogCreateProject>
        <Button variant="outline" size="sm">
          <FolderOpen class="mr-2 h-4 w-4" />
          Add Root/Master Project
        </Button>
      </DialogCreateProject>
    </div>
  </div>
</template>